import { type ConfluenceDatabaseUpdateCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';

import {
  AI_FIELD_STREAM_ACTIVE_ERROR_MESSAGE,
  DatabaseStreamState
} from '../database-stream-state.ts';
import { sendDatabaseAIFCExperienceTrackingToParent } from '../metrics/rovo-bridge-database-metrics.ts';

const streamState = DatabaseStreamState.getInstance();

export const editDatabase = async (
  params: ConfluenceDatabaseUpdateCommandProperties,
  contentId: string
) => {
  try {
    if (streamState.isAiFieldStreamingActive) {
      throw new Error(AI_FIELD_STREAM_ACTIVE_ERROR_MESSAGE);
    }

    if (
      !streamState.isStreamingActive &&
      (!params.isStreamComplete || params.data.document.trim().length > 0)
    ) {
      sendDatabaseAIFCExperienceTrackingToParent({
        status: 'success',
        experienceName: 'aiMateAifcInitialDataReceived',
        contentId
      });
    }

    if (params.isStreamComplete) {
      // await needed to ensure snapshot is taken after all tokens are processed
      await streamState.completeStreaming();
      streamState.scheduleActionedEvaluation(
        contentId,
        'edit',
        params.singleInstrumentationID ?? ''
      );
      sendDatabaseAIFCExperienceTrackingToParent({
        status: 'success',
        experienceName: 'aiMateAifcAllDataHandled',
        contentId
      });
      streamState.markAllDataHandled();
      return;
    }

    if (!streamState.isStreamingActive) {
      streamState.startStreaming(contentId, params.groupId, {
        operationType: 'edit'
      });
    }

    streamState.processChunk(params.data.document);
  } catch (possibleError) {
    const error =
      possibleError instanceof Error ? possibleError : new Error(String(possibleError));
    sendDatabaseAIFCExperienceTrackingToParent({
      status: 'fail',
      error,
      experienceName: 'aiMateAifcAllDataHandled',
      contentId
    });
    throw error;
  }
};
